












import Vue from "vue";
import Basket from "@/views/client/Basket.vue";

export default Vue.extend({
  components: {
    Basket
  }
});
